import {
    AUDIO_MEDIA_TYPES,
    MEDIA_SOURCES,
    MEDIA_TYPES,
    VIDEO_MEDIA_TYPES,
} from 'constants/dance.js'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {useAddMediaMutation, useI18n, useIsRtl} from 'store/Store'

const useAddMediaDialog = (handleClose) => {
    const [tab, setTab] = useState('file')
    const [mediaUrl, setMediaUrl] = useState('')
    const [description, setDescription] = useState('')
    const [uploadedFile, setUploadedFile] = useState({
        url: '',
        name: '',
        fileExtension: '',
    })
    const [openSnackbar, setOpenSnackbar] = useState(false)

    const isRtl = useIsRtl()
    const {i18n} = useI18n()
    const {danceId} = useParams()
    const [createMediaAndAttachToDance, {isError, isLoading}] =
        useAddMediaMutation()

    const t = (label) => i18n.t(`dance.${label}`)

    const resetStates = () => {
        setMediaUrl('')
        setDescription('')
        setUploadedFile({
            url: '',
            name: '',
            fileExtension: '',
        })
    }

    const handleSubmit = async () => {
        const mediaData = {
            description,
            source: MEDIA_SOURCES.rikudIsraeli,
        }
        if (tab === 'file') {
            const {url, name, fileExtension} = uploadedFile
            mediaData.url = url
            mediaData.name = name
            mediaData.mediaType = VIDEO_MEDIA_TYPES.includes(
                `.${fileExtension}`
            )
                ? MEDIA_TYPES.video
                : MEDIA_TYPES.song
        } else if (tab === 'url') {
            mediaData.url = mediaUrl
            mediaData.mediaType = MEDIA_TYPES.video
        }
        try {
            await createMediaAndAttachToDance({
                danceId,
                body: mediaData,
            }).unwrap()
            handleClose()
            setOpenSnackbar(true)
            resetStates()
        } catch (e) {
            console.log(e)
        }
    }

    const handleTabChange = (_, newValue) => {
        setTab(newValue)
    }

    return {
        isRtl,
        tab,
        isLoading,
        isError,
        setUploadedFile,
        uploadedFile,
        mediaUrl,
        setMediaUrl,
        description,
        setDescription,
        handleTabChange,
        handleSubmit,
        openSnackbar,
        setOpenSnackbar,
        acceptedMediaTypes: [...VIDEO_MEDIA_TYPES, ...AUDIO_MEDIA_TYPES].join(
            ','
        ),
        // Text labels
        descriptionText: t('description'),
        songText: t('song'),
        videoText: t('video'),
        addLinkText: t('addLinkMedia'),
        addFileMediaText: t('addFileMedia'),
        addMediaText: t('addMedia'),
        addText: t('add'),
        cancelText: t('cancel'),
        uploadMediaText: t('uploadMedia'),
        selectedMediaText: t('selectedMedia'),
        mediaUrlText: t('mediaUrl'),
        addMediaInfoText: t('addMediaInfo'),
        mediaAddedSuccessfullyText: t('mediaAddedSuccessfully'),
        supportedMediaTypesText: t('supportedMediaTypes'),
    }
}

export default useAddMediaDialog
